import { useCallback } from 'react';

import { logError } from '@/helpers/logger/logUtils';

import { DataSubjectDetails, Consent } from '@/helpers/virginCommsOptSchema';

type User = {
  email: string;
  firstName: string;
  lastName: string;
  dob: string;
};

const FALLBACK_COUNTRY_CODE = 'US';

type UsePostConsentProps = {
  userConsent: Function;
  countryCode?: string;
  commsOptConsent: boolean;
};

export function usePostConsent({ userConsent, countryCode, commsOptConsent }: UsePostConsentProps) {
  return useCallback(
    async (payload: User, token: string | undefined) => {
      if (!commsOptConsent) return;

      const { email, firstName, lastName, dob } = payload;

      const dataSubjectDetails: DataSubjectDetails = {
        email,
        firstName,
        lastName,
        dateOfBirth: dob,
        countryCode: countryCode || FALLBACK_COUNTRY_CODE,
      };

      const consent: Consent[] = [
        { name: 'Group Marketing Consent', consentStatus: 'CONFIRMED' },
        { name: 'Data Sharing', consentStatus: 'CONFIRMED' },
      ];

      try {
        await userConsent({
          variables: { consent, dataSubjectDetails },
          context: {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        });
      } catch (err) {
        logError(`Error while posting consent: ${err?.toString()}`);
      }
    },
    [userConsent, countryCode, commsOptConsent],
  );
}
